export default {"src":"/sitetest/_next/static/media/first_nav_active04.8945a3cd.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};